"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var helios_decoration_1 = require("@carvana/helios-decoration");
var Tag_1 = __importDefault(require("../../icons/Tag"));
var InfoCard_styles_1 = require("./InfoCard.styles");
var InfoCard = function (_a) {
    var description = _a.description, lineItems = _a.lineItems, name = _a.name, savingsTagText = _a.savingsTagText, title = _a.title;
    return ((0, jsx_runtime_1.jsxs)(InfoCard_styles_1.StyledInfoCard, __assign({ className: "info-card info-card__".concat(name) }, { children: [savingsTagText && ((0, jsx_runtime_1.jsx)(InfoCard_styles_1.SavingsTagWrapper, { children: (0, jsx_runtime_1.jsxs)(helios_decoration_1.Badge, __assign({ priority: "successSubtle" }, { children: [(0, jsx_runtime_1.jsx)(Tag_1.default, {}), "\u00A0\u00A0", savingsTagText] })) })), (0, jsx_runtime_1.jsx)("div", __assign({ className: "info-card__title" }, { children: title })), (0, jsx_runtime_1.jsx)("div", __assign({ className: "info-card__description" }, { children: description })), (0, jsx_runtime_1.jsx)("div", { className: "horizontal-rule" }), lineItems === null || lineItems === void 0 ? void 0 : lineItems.map(function (item) { return ((0, jsx_runtime_1.jsxs)("div", __assign({ className: "info-card__line-item" }, { children: [(0, jsx_runtime_1.jsx)("span", { children: item.title }), (0, jsx_runtime_1.jsx)("span", { children: item.amount })] }), item.title)); })] })));
};
exports.default = InfoCard;
